import React from "react";
import "./style/basketTableStyle.scss";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import "../../../style/hovers.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  total: number;
  primaryPrice?: number;
}

const BasketSummary: React.FC<IProps> = ({ total, primaryPrice }: IProps) => {
  const { t } = useTranslation();

  const isPriceIncludePromotion = () => {
    return Boolean(primaryPrice && primaryPrice > total);
  };

  return (
    <>
      <div className="basket-summary">
        <h3>{t("podsumowanie_zamowienia")}</h3>
        {isPriceIncludePromotion() && (
          <>
            {" "}
            <div className="main-line flex-between-center">
              <span>{t("lacznie")}:</span>
              <b>
                {primaryPrice} {t("zl")}
              </b>
            </div>
            <div className="main-line flex-between-center saving-info">
              <span>{t("oszczedasz")}:</span>
              <b>
                {(Number(primaryPrice) - total).toFixed(2)} {t("zl")}
              </b>
            </div>
          </>
        )}

        <div className="summary-line flex-between-center">
          <span>{t("do_zaplaty")}:</span>
          <b>
            {total.toFixed(2)} {t("zl")}
          </b>
        </div>
      </div>
    </>
  );
};

export default BasketSummary;
